import React from 'react';
import * as BuilderInfoUI from '../../BuilderInfoUI';
import {
  IMeasureFieldsFragment,
  IMeasurePropertiesFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import SimpleMeasureInfo from './SimpleMeasureInfo';
import { parseMeasureInfo } from './parseMeasureInfo';
import MeasureFormulaInfo from './MeasureFormulaInfo';

interface IProps {
  measure: IMeasureFieldsFragment;
  showLabels: boolean;
  measureProperties?: IMeasurePropertiesFieldsFragment;
}

const BuilderMeasureInfo = ({
  measure,
  showLabels,
  measureProperties,
}: IProps) => {
  const { measures, formula } = parseMeasureInfo(
    measure,
    measureProperties || null,
  );

  return (
    <BuilderInfoUI.VerticalRow>
      {measures.map(({ simpleMeasure, cohorts }, index) => (
        <SimpleMeasureInfo
          key={`builder-info-simple-measure-${index}`}
          simpleMeasure={simpleMeasure}
          cohorts={cohorts}
          rowIndex={showLabels ? index : undefined}
        />
      ))}
      {formula && <MeasureFormulaInfo formula={formula} />}
    </BuilderInfoUI.VerticalRow>
  );
};

export default BuilderMeasureInfo;
